export enum ALMFlowTypes {
    APPVD = 'APPVD',
    CUST_FLOW = 'CUST_FLOW',
    APPLICATION_SUMMARY  = 'APPLICATION_SUMMARY',
    NONE = ''
}